// extracted by mini-css-extract-plugin
export default {"app":"SendFriendInvite_app__VsM7A","headerBar":"SendFriendInvite_headerBar__HYByY","view":"SendFriendInvite_view__PQmyQ"};